import {i18nKey} from '@/locales/i18n';
import IconView from '@/assets/icons/ic_view.svg';

export enum INVOICE_LIST_FILTER {
  NAME = 'name',
  TENANT_ID = 'tenantId',
  PAYMENT_STATUS = 'paymentStatus',
  BILL_MONTH = 'billMonth',
  DEPARTMENT_NAME = 'departmentName',
}

export const ITEM_STATUS_INVOICE = [
  {value: 4, label: () => i18nKey.invoiceScreen.status.all},
  {value: 1, label: () => i18nKey.invoiceScreen.status.pending},
  {value: 2, label: () => i18nKey.invoiceScreen.status.paid},
  {value: 3, label: () => i18nKey.invoiceScreen.status.overdue},
];

export const INVOICE_REQUEST_STATUS = {
  Processing: 1,
  Success: 2,
  Failed: 3,
};

export const INVOICE_PAYMENT_STATUS = {
  Pending: 1,
  Paid: 2,
  Overdue: 3,
};

export const ITEM_ACTION_INVOICE = [
  {
    key: '1',
    label: () => i18nKey.invoiceScreen.action.view,
    icon: IconView,
  },
  {
    key: '3',
    label: () => i18nKey.invoiceScreen.action.exportPayment,
    icon: IconView,
  },
];

export const MENU_KEY_INVOICE = {
  VIEW: '1',
  EXPORT_PAYMENT: '2',
};
